import { ILexingError, IRecognitionException } from 'chevrotain';
import { ValueNode } from 'graphql';
import * as monacoEditor from 'monaco-editor';

import { cstSharedConversions } from './cstSharedConversions';
import { parseValueCST } from './parseValueCST';

let lastRun:
  | {
      documentText: string;
      result: {
        valueNode: ValueNode | undefined;
        lexErrors: ILexingError[];
        parseErrors: IRecognitionException[];
      };
    }
  | undefined;
export function tolerantParseValue(
  model: monacoEditor.editor.ITextModel,
  range: monacoEditor.Range,
) {
  const documentText = model.getValueInRange(range);
  if (!lastRun || documentText !== lastRun.documentText) {
    const { value, lexErrors, parseErrors } = parseValueCST(documentText, {
      index: model.getOffsetAt(range.getStartPosition()),
      line: range.startLineNumber - 1,
      column: range.startColumn - 1,
    });
    const { valueToAst } = cstSharedConversions(model);
    const valueNode = valueToAst(value);
    lastRun = {
      documentText,
      result: { valueNode, lexErrors, parseErrors },
    };
  }
  return lastRun.result;
}
